import styled, { css } from 'styled-components';

export const SelectStoreButtonWrapper = styled.div`
    padding-top: 10px;
    margin-bottom: 30px;
`;

export const MyStoreStyled = styled.div`
    ${({ theme }) => css`
        margin-left: 10px;
        margin-bottom: 20px;

        font-weight: 700;
        color: ${theme.color.green};
        font-size: 15px;
        line-height: 24px;

        svg {
            margin-right: 10px;

            color: ${theme.color.green};
        }
    `}
`;
